import React, { useState, useEffect } from 'react';
import { getDescription } from '../util/fetchRomDescription';
import { LocaleString } from '@nackle/intl-tools';
import { Button, Modal } from '@nackle/origami';

const InstructionsDialog = ( props ) => {
    const [ dynamicRomDescription, setDynamicRomDescription ] = useState( '' );
    const {
        open,
        onClose,
        romId,
        localeCode,
        session,
        isUmbrella,
        env
    } = props;

    useEffect( () => {
        let isMounted = true;

        async function loadRomDescription() {
            if ( !romId || !localeCode ) {return;}
            try {
                const res = await getDescription( romId, localeCode, session, isUmbrella, env );
                if ( isMounted ) {
                    setDynamicRomDescription( res?.description || '' );
                }
            } catch {
                if ( isMounted ) {
                    setDynamicRomDescription( '' );
                }
            }
        }
        loadRomDescription();
        return () => {
            isMounted = false;
        };
    }, [ romId, localeCode ] );

    return (
        <Modal
            getContainer=".game-container"
            open={ open }
            onCancel={ onClose }
            centered
            className="game-loader-instructions-modal"
            title={ <LocaleString code="game.loader.INSTRUCTIONS.MODAL.HEADER" /> }
            footer={ (
                <Button
                    id="instructions_dialog_close"
                    type="primary"
                    onClick={ onClose }
                >
                    <LocaleString code="game.loader.INSTRUCTIONS.MODAL.CLOSE.BUTTON" />
                </Button>
            ) }
        >
                { dynamicRomDescription }
        </Modal>
    );
};

export default InstructionsDialog;